export default "__VITE_ASSET__a1430cdf__"